import { ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { Dropdown, Button } from "react-bootstrap";

const DropdownProfile = ({ userName }) => {
  const [show, setShow] = useState(false);

  const toggleDropdown = () => setShow((prev) => !prev);

  const handleLogout = () => {
    alert("Logging out...");
    // Add your logout logic here
  };

  return (
    <Dropdown
    // show={show} onToggle={() => setShow(!show)}
    >
      <Dropdown.Toggle
        as="div"
        className="dropdown-toggle-profile"
        onClick={toggleDropdown}
      >
        <span className="d-flex align-items-center caret-hidden gap-1">
          {userName}
          {/* <ChevronDown /> */}
        </span>
      </Dropdown.Toggle>

      {/* <Dropdown.Menu
        align="end"
        className="dropdown-menu-profile"
      >
        <Button variant="danger" onClick={handleLogout} block>
          Logout
        </Button>
      </Dropdown.Menu> */}
    </Dropdown>
  );
};

export default DropdownProfile;
